import i18n from '@/languages/languages'
import moment from 'moment'
import VueCookie from 'vue-cookie'

let array = [
  {
    name: i18n.t('menu.dashboard.index'),
    icon: 'far fa-university',
    path: '/admin/timetable/dashboard',
    type: 'dashboard',
    view: 'TimetableDashboard'
  },
  {
    name: i18n.t('menu.dashboardClient.index'),
    icon: 'far fa-university',
    path: '/admin/dashboard/client',
    type: 'dashboard',
    view: 'ClientDashboard'
  },
  {
    name: i18n.t('menu.orders.index'),
    icon: 'far fa-file-alt',
    path: '/admin/e_x_s_b_orders/list',
    type: 'dashboard',
    view: 'WholesalerOrders'
  },
  {
    name: 'CRM',
    icon: 'far fa-building',
    type: 'firms',
    children: [
      {
        name: i18n.t('menu.firm.index'),
        path: '/admin/firm/list',
        type: 'firms',
        view: 'FirmList'
      },
      {
        name: i18n.t('menu.userdataemployee.index'),
        path: '/admin/user_data_employees/list',
        type: 'firms',
        view: 'UserDataEmployeeList'
      },
      {
        name: i18n.t('menu.application.index'),
        path: '/admin/applications/list',
        type: 'application',
        view: 'ApplicationList'
      },
      {
        name: i18n.t('menu.relations.list'),
        path: '/admin/e_x_c_m_relations/list',
        type: 'firms',
        view: 'EXCMRelationsList'
      },
      {
        name: i18n.t('menu.excmcalllogs.list'),
        path: '/admin/e_x_c_m_call_logs/list',
        type: 'firms',
        view: 'EXCMCallLogList'
      },
      {
        name: i18n.t('menu.excmcorrespondence.list'),
        path: '/admin/e_x_c_m_correspondence_threads/list',
        type: 'firms',
        view: 'EXCMCorrespondenceThreadsList'
      },
      {
        name: i18n.t('menu.excmchatbot.list'),
        path: '/admin/e_x_c_m_chatbot_threads/list',
        type: 'firms',
        view: 'EXCMChatbotThreadsList'
      },
      {
        name: i18n.t('menu.internalannouncements.list'),
        path: '/admin/internal_announcements/list',
        type: 'application',
        view: 'InternalAnnouncements'
      },
      {
        name: i18n.t('menu.exaborganizationleads.list'),
        path: '/admin/e_x_a_b_organization_leads/list',
        type: 'firms',
        view: 'EXABOrganizationLeadList'
      }
    ]
  },
  {
    name: i18n.t('menu.agreements.index'),
    icon: 'far fa-handshake',
    type: 'exabagreements',
    children: [
      {
        name: i18n.t('menu.agreements.create'),
        path: '/admin/agreements/create',
        type: 'exabagreements',
        view: 'EXABAgreementsCreate'
      },
      {
        name: i18n.t('menu.agreements.listAll'),
        path: '/admin/agreements/listall',
        type: 'exabagreements',
        view: 'EXABAgreementsList'
      },
      {
        name: i18n.t('menu.agreements.listSigned'),
        path: '/admin/agreements/listsigned',
        type: 'exabagreements'
      },
      {
        name: i18n.t('menu.promotions.list'),
        path: '/admin/agreements/promotions/list',
        type: 'exabagreements',
        view: 'EXABPromotionsList'
      },
      {
        name: i18n.t('menu.customfields.list'),
        path: '/admin/agreements/customfields/list',
        type: 'exabagreements',
        view: 'EXABCustomFieldsList'
      }
    ]
  },
  {
    name: i18n.t('menu.agreementsoffers.index'),
    icon: 'far fa-envelope-open-text',
    type: 'exabagreements',
    children: [
      {
        name: i18n.t('menu.agreementsoffers.create'),
        path: '/admin/agreementsoffers/create',
        type: 'exabagreements',
        view: 'EXABAgreementsCreate'
      },
      {
        name: i18n.t('menu.agreements.listOffers'),
        path: '/admin/agreementsoffers/listall',
        type: 'exabagreements',
        view: 'EXABAgreementsListOffers'
      },
      {
        name: i18n.t('menu.agreements.listWaiting'),
        path: '/admin/agreementsoffers/listwaiting',
        type: 'exabagreements',
        view: 'EXABAgreementsListWaiting'
      },
      {
        name: i18n.t('menu.agreements.listAccepted'),
        path: '/admin/agreementsoffers/listaccepted',
        type: 'exabagreements'
      },
      {
        name: i18n.t('menu.agreements.listInProgress'),
        path: '/admin/agreementsoffers/listinprogress',
        type: 'exabagreements'
      },
      {
        name: i18n.t('menu.agreements.listRejected'),
        path: '/admin/agreementsoffers/listrejected',
        type: 'exabagreements'
      },
      {
        name: i18n.t('menu.externalForms.list'),
        path: '/admin/agreements/externalforms/list',
        type: 'exabagreements',
        view: 'EXABExternalFormsList'
      },
      {
        name: i18n.t('routes.AgreementFileUploadCreate'),
        path: '/admin/agreement_file_upload/create',
        type: 'exabagreements',
        view: 'EXABPackagesList'
      },
      {
        name: i18n.t('routes.ContractorFileUploadCreate'),
        path: '/admin/contractor_file_upload/create',
        type: 'exabagreements',
        view: 'EXABPackagesList'
      },
      {
        name: i18n.t('menu.surveys.list'),
        path: '/admin/agreements/surveys/list',
        type: 'exabagreements',
        view: 'EXABSurveysList'
      },
      {
        name: i18n.t('menu.surveyresults.list'),
        path: '/admin/agreements/surveyresults/list',
        type: 'exabagreements',
        view: 'EXABSurveysList'
      }
    ]
  },
  {
    name: i18n.t('menu.excmagreements.index'),
    icon: 'far fa-file-contract',
    type: 'agreements',
    children: [
      {
        name: i18n.t('menu.agreements.list'),
        path: '/admin/e_x_c_m_agreements/list',
        type: 'agreements',
        view: 'EXCMAgreementList'
      },
      {
        name: i18n.t('menu.slas.list'),
        path: '/admin/e_x_c_m_slas/list',
        type: 'agreements',
        view: 'EXCMSlaList'
      },
      {
        name: i18n.t('menu.consents.list'),
        path: '/admin/e_x_c_m_consents/list',
        type: 'agreements',
        view: 'EXCMConsentList'
      }
    ]
  },
  {
    name: i18n.t('menu.devices.index'),
    icon: 'far fa-print',
    type: 'devices',
    children: [
      {
        name: i18n.t('menu.devices.list'),
        path: '/admin/e_x_c_m_devices/list',
        type: 'devices',
        view: 'EXCMDeviceList'
      },
      {
        name: i18n.t('menu.devicestates.list'),
        path: '/admin/e_x_c_m_device_states/list',
        type: 'devices',
        view: 'EXCMDeviceStateList'
      },
      {
        name: i18n.t('menu.agreementdevices.list'),
        path: '/admin/e_x_c_m_agreement_devices/list',
        type: 'devices',
        view: 'EXCMAgreementDeviceList'
      }
    ]
  },
  {
    name: i18n.t('menu.service.index'),
    icon: 'far fa-hard-hat',
    type: 'cases',
    children: [
      {
        name: i18n.t('menu.cases.listOpen'),
        path: '/admin/e_x_c_m_cases/list_open',
        type: 'cases',
        view: 'EXCMCaseList'
      },
      {
        name: i18n.t('menu.cases.listClose'),
        path: '/admin/e_x_c_m_cases/list_close',
        type: 'cases',
        view: 'EXCMCaseList'
      },
      {
        name: i18n.t('menu.ticket.list'),
        path: '/admin/ticket/list',
        type: 'cases',
        view: 'TicketList'
      },
      {
        name: i18n.t('menu.tasks.list'),
        path: '/admin/e_x_c_m_tasks/list',
        type: 'tasks',
        view: 'EXCMTaskList'
      },
      {
        name: i18n.t('menu.cyclictask.list'),
        path: '/admin/e_x_c_m_cyclic_tasks/list',
        type: 'tasks',
        view: 'EXCMCyclicTaskList'
      }
    ]
  },
  {
    name: i18n.t('menu.finance.index'),
    type: 'finances',
    icon: 'far fa-credit-card',
    children: [
      {
        name: i18n.t('menu.invoices.listNotAccepted'),
        path: '/admin/e_x_s_b_not_accepted_invoices/list?a=0',
        type: 'finances',
        view: 'EXSBInvoiceList',
        isRoute: true
      },
      {
        name: i18n.t('menu.invoices.list'),
        path: '/admin/e_x_s_b_invoices/list',
        type: 'finances',
        view: 'EXSBInvoiceList'
      },
      {
        name: i18n.t('menu.invoices.listVindication'),
        path: '/admin/e_x_s_b_vindication_invoices/list',
        type: 'finances',
        view: 'EXSBInvoiceList',
        isRoute: true
      },
      {
        name: i18n.t('menu.exsbbank.index'),
        path: '/admin/e_x_s_b_banks/list',
        type: 'finances',
        view: 'EXSBBankList'
      },
      {
        name: i18n.t('menu.exsbbankpackages.index'),
        path: '/admin/e_x_s_b_bank_packages/list',
        type: 'finances',
        view: 'EXSBBankList'
      },
      {
        name: i18n.t('menu.exsbpaymentsmade.index'),
        path: '/admin/e_x_s_b_payments_mades/list',
        type: 'finances',
        view: 'EXSBPaymentsMadeList'
      },
      {
        name: i18n.t('menu.exsbmessagesperiodic.index'),
        path: '/admin/e_x_s_b_messages_periodics/list',
        type: 'finances',
        view: 'EXSBPaymentsMadeList'
      },
      {
        name: i18n.t('menu.exsbrefund.index'),
        path: '/admin/e_x_s_b_refunds/list',
        type: 'finances',
        view: 'EXSBRefundList'
      }
    ]
  },
  {
    name: i18n.t('menu.servicemen.index'),
    icon: 'far fa-people-carry',
    type: 'servicemen',
    children: [
      {
        name: i18n.t('menu.teams.list'),
        path: '/admin/e_x_c_m_teams/list',
        type: 'servicemen',
        view: 'EXCMTeamList'
      },
      {
        name: i18n.t('menu.servicemen.itemspicking'),
        path: '/admin/e_x_s_b/automats/serviceman_items_picking',
        type: 'servicemen',
        view: 'ServicemanItemsPicking'
      },
      {
        name: i18n.t('menu.servicemen.itemsreturning'),
        path: '/admin/e_x_s_b/automats/serviceman_items_returning',
        type: 'servicemen',
        view: 'ServicemanItemsReturning'
      },
      {
        name: i18n.t('menu.servicemen.index'),
        path: '/admin/servicemen/list',
        type: 'servicemen',
        view: 'ServicemenList'
      },
      {
        name: i18n.t('menu.dailyplanoverview.show'),
        path: '/admin/daily_plan/overview/%2Fapi%2Fuser_datas%2F' + VueCookie.get('user_data_id') + '/' + moment().format('YYYY-MM'),
        type: 'servicemen',
        view: 'DailyPlanOverviewForServiceman'
      }
    ]
  },
  {
    name: i18n.t('menu.warehouse.index'),
    icon: 'far fa-warehouse-alt',
    type: 'warehouses',
    children: [
      {
        name: i18n.t('menu.documents.list'),
        path: '/admin/e_x_s_b_documents/list',
        type: 'warehouses',
        view: 'EXSBDocumentList'
      },
      {
        name: i18n.t('menu.orders.index'),
        path: '/admin/e_x_s_b_orders/list',
        type: 'orders',
        view: 'EXSBOrderList'
      },
      {
        name: i18n.t('menu.items.list'),
        path: '/admin/e_x_s_b_items/list',
        type: 'warehouses',
        view: 'EXSBItemList'
      },
      {
        name: i18n.t('menu.warehouses.list'),
        path: '/admin/e_x_s_b_warehouses/list',
        type: 'warehouses',
        view: 'EXSBWarehouseList'
      },
      {
        name: i18n.t('menu.packages.list'),
        path: '/admin/agreements/packages/list',
        type: 'exabagreements',
        view: 'EXABPackagesList'
      }
    ]
  },
  {
    name: i18n.t('menu.reports.index'),
    icon: 'far fa-chart-bar',
    type: 'configuration',
    children: [
      {
        name: i18n.t('menu.reports.permissions'),
        path: '/admin/reports/permissions',
        type: 'configuration',
        view: 'PermissionsReportList'
      },
      {
        name: i18n.t('menu.logs.list'),
        path: '/admin/log/list',
        type: 'configuration',
        view: 'LogList'
      },
      {
        name: i18n.t('menu.messages.list'),
        path: '/admin/e_x_c_m_messages/list',
        type: 'configuration',
        view: 'EXCMMessageList'
      },
      {
        name: i18n.t('menu.financialreport.list'),
        path: '/admin/financial_report/list',
        type: 'configuration',
        view: 'FinancialReportList'
      },
      {
        name: i18n.t('menu.emptypaymentsmades.list'),
        path: '/admin/empty_payments_mades/list',
        type: 'configuration',
        view: 'FinancialReportList'
      },
      {
        name: i18n.t('menu.notfullbankpayments.list'),
        path: '/admin/not_full_bank_payments/list',
        type: 'configuration',
        view: 'FinancialReportList'
      },
      {
        name: i18n.t('menu.contactdatareport.list'),
        path: '/admin/contact_data/list',
        type: 'configuration',
        view: 'ContactDataReportList'
      },
      {
        name: i18n.t('menu.invoicesbalancereport.list'),
        path: '/admin/invoices_balance/list',
        type: 'configuration',
        view: 'ContactDataReportList'
      },
      {
        name: i18n.t('menu.customfieldsreport.list'),
        path: '/admin/e_x_c_m_custom_fields_report/list',
        type: 'configuration',
        view: 'EXCMCustomFieldsReportList'
      }
    ]
  },
  {
    name: i18n.t('menu.configuration.index'),
    icon: 'far fa-cogs',
    type: 'configuration',
    children: [
      {
        name: i18n.t('menu.userdatas.list'),
        path: '/admin/user_datas/list',
        type: 'userdatas',
        view: 'UserDataList'
      },
      {
        name: i18n.t('menu.user.list'),
        path: '/admin/users/list',
        type: 'userdatas',
        view: 'UserList'
      },
      {
        name: i18n.t('menu.userdatastatus.list'),
        path: '/admin/e_x_c_m_user_data_statuses/list',
        type: 'firms',
        view: 'EXCMUserDataStatusList'
      },
      {
        name: i18n.t('menu.userdatasalesopportunities.list'),
        path: '/admin/e_x_c_m_user_data_sales_opportunities/list',
        type: 'firms',
        view: 'EXCMUserDataSalesOpportunityList'
      },
      {
        name: i18n.t('menu.userdatastatus.list'),
        path: '/admin/e_x_c_m_user_data_sales_opportunities/list',
        type: 'configuration',
        view: 'EXCMUserDataStatusList'
      },
      {
        name: i18n.t('menu.userdataworkplace.list'),
        path: '/admin/e_x_c_m_user_data_workplaces/list',
        type: 'configuration',
        view: 'EXCMUserDataWorkplaceList'
      },
      {
        name: i18n.t('menu.regions.list'),
        path: '/admin/e_x_c_m_regions/list',
        type: 'configuration',
        view: 'EXCMRegionList'
      },
      {
        name: i18n.t('menu.salesopportunities.list'),
        path: '/admin/e_x_c_m_user_data_sales_opportunities/list',
        type: 'configuration',
        view: 'SalesOpportunityList'
      },
      {
        name: i18n.t('menu.casetypes.list'),
        path: '/admin/e_x_c_m_case_types/list',
        type: 'configuration',
        view: 'EXCMCaseTypeList'
      },
      {
        name: i18n.t('menu.tags.list'),
        path: '/admin/e_x_c_m_tags/list',
        type: 'configuration',
        view: 'EXCMTagList'
      },
      {
        name: i18n.t('menu.tasktypes.list'),
        path: '/admin/e_x_c_m_task_types/list',
        type: 'configuration',
        view: 'EXCMTaskTypeList'
      },
      // application
      {
        name: i18n.t('menu.sqlscriptexecuted.list'),
        path: '/admin/sql_script_executeds',
        type: 'application',
        view: 'SQLScriptExecuted'
      },
      {
        name: i18n.t('menu.application.runSQLScript'),
        path: '/admin/applications/runsqlscript',
        type: 'application',
        view: 'ApplicationRunSQL'
      },
      {
        name: i18n.t('menu.database.index'),
        path: '/admin/databases/list',
        type: 'database',
        view: 'DatabaseList'
      },
      {
        name: i18n.t('menu.server.index'),
        path: '/admin/servers/list',
        type: 'server',
        view: 'ServerList'
      },
      {
        name: i18n.t('menu.batchnumbers.list'),
        path: '/admin/e_x_s_b_batch_numbers/list',
        type: 'warehouses',
        view: 'EXSBBatchNumberList'
      },
      {
        name: i18n.t('menu.delivery.list'),
        path: '/admin/e_x_s_b_deliveries/list',
        type: 'warehouses',
        view: 'EXSBDeliveryList'
      },
      {
        name: i18n.t('menu.itemscategories.list'),
        path: '/admin/e_x_s_b_items_categories/list',
        type: 'warehouses',
        view: 'EXSBItemCategoryList'
      },
      {
        name: i18n.t('menu.pricegroups.list'),
        path: '/admin/e_x_s_b_price_groups/list',
        type: 'warehouses',
        view: 'EXSBPriceGroupList'
      },
      // {
      //   name: i18n.t('menu.tags.list'),
      //   path: '/admin/e_x_c_m_tags/list',
      //   type: 'warehouses',
      //   view: 'EXSBTags'
      // },
      {
        name: i18n.t('menu.itembrands.list'),
        path: '/admin/e_x_s_b_item_brands/list',
        type: 'warehouses',
        view: 'EXSBItemBrandList'
      },
      {
        name: i18n.t('menu.measures.list'),
        path: '/admin/e_x_s_b_measures/list',
        type: 'warehouses',
        view: 'EXSBMeasureList'
      },
      {
        name: i18n.t('menu.devicebrands.list'),
        path: '/admin/e_x_c_m_device_brands/list',
        type: 'devices',
        view: 'EXCMDeviceBrandList'
      },
      {
        name: i18n.t('menu.devicemodels.list'),
        path: '/admin/e_x_c_m_device_models/list',
        type: 'devices',
        view: 'EXCMDeviceModelList'
      },
      {
        name: i18n.t('menu.devicetypes.list'),
        path: '/admin/e_x_c_m_device_types/list',
        type: 'devices',
        view: 'EXCMDeviceTypeList'
      },
      {
        name: i18n.t('menu.deviceperipherals.list'),
        path: '/admin/e_x_c_m_device_peripherals/list',
        type: 'devices',
        view: 'EXCMDevicePeripheralList'
      },
      {
        name: i18n.t('menu.cars.list'),
        path: '/admin/e_x_c_m_cars/list',
        type: 'configuration',
        view: 'EXCMCarList'
      },
      {
        name: i18n.t('menu.agreementtypes.list'),
        path: '/admin/e_x_c_m_agreement_types/list',
        type: 'configuration',
        view: 'EXCMAgreementTypeList'
      },
      {
        name: i18n.t('menu.excmnotificationmessage.list'),
        path: '/admin/e_x_c_m_notification_messages/list',
        type: 'configuration',
        view: 'EXCMNotificationMessageList'
      },
      {
        name: i18n.t('menu.exsbpriceuserdata.list'),
        path: '/admin/e_x_s_b_price_userdata/list',
        type: 'warehouses',
        view: 'EXSBPriceUserDataList'
      },
      {
        name: i18n.t('menu.documenttemplate.list'),
        path: '/admin/document_templates/list',
        type: 'configuration',
        view: 'DocumentTemplateList'
      },
      {
        name: i18n.t('menu.documenttype.list'),
        path: '/admin/document_type/list',
        type: 'configuration'
      },
      {
        name: i18n.t('menu.excmrelationcategory.list'),
        path: '/admin/e_x_c_m_relation_categories/list',
        type: 'configuration'
      }
    ]
  },
  {
    name: i18n.t('TRASH'),
    icon: 'fa fa-trash',
    type: 'trash',
    children: [
      {
        name: i18n.t('menu.agreements.create'),
        path: '/admin/e_x_c_m_agreements/create',
        type: 'agreements',
        view: 'EXCMAgreementCreate'
      },
      {
        name: i18n.t('menu.agreementtypes.create'),
        path: '/admin/e_x_c_m_agreement_types/create',
        type: 'configuration',
        view: 'EXCMAgreementTypeCreate'
      },
      {
        name: i18n.t('menu.cars.create'),
        path: '/admin/e_x_c_m_cars/create',
        type: 'configuration',
        view: 'EXCMCarCreate'
      },
      {
        name: i18n.t('menu.consents.create'),
        path: '/admin/e_x_c_m_consents/create',
        type: 'agreements',
        view: 'EXCMConsentCreate'
      },
      {
        name: i18n.t('menu.slas.create'),
        path: '/admin/e_x_c_m_slas/create',
        type: 'agreements',
        view: 'EXCMSlaCreate'
      },
      {
        name: i18n.t('menu.cyclictask.create'),
        path: '/admin/e_x_c_m_cyclic_tasks/create',
        type: 'agreements',
        view: 'EXCMCyclicTaskCreate'
      },
      {
        name: i18n.t('menu.devices.create'),
        path: '/admin/e_x_c_m_devices/create',
        type: 'devices',
        view: 'EXCMDeviceCreate'
      },
      // brand
      {
        name: i18n.t('menu.devicebrands.create'),
        path: '/admin/e_x_c_m_device_brands/create',
        type: 'devices',
        view: 'EXCMDeviceBrandCreate'
      },
      // model
      {
        name: i18n.t('menu.devicemodels.create'),
        path: '/admin/e_x_c_m_device_models/create',
        type: 'devices',
        view: 'EXCMDeviceModelCreate'
      },
      // type
      {
        name: i18n.t('menu.devicetypes.create'),
        path: '/admin/e_x_c_m_device_types/create',
        type: 'devices',
        view: 'EXCMDeviceTypeCreate'
      },
      // peripheral
      {
        name: i18n.t('menu.deviceperipherals.create'),
        path: '/admin/e_x_c_m_device_peripherals/create',
        type: 'devices',
        view: 'EXCMDevicePeripheralCreate'
      },
      {
        name: i18n.t('menu.relations.list'),
        path: '/admin/e_x_c_m_relations/list',
        type: 'configuration',
        view: 'EXCMRelationList'
      },
      {
        name: i18n.t('menu.client.list'),
        path: '/admin/clients/list',
        type: 'clients',
        view: 'ClientList'
      },
      {
        name: i18n.t('menu.client.create'),
        path: '/admin/clients/create',
        type: 'clients',
        view: 'ClientCreate'
      },
      {
        name: i18n.t('menu.relations.list'),
        path: '/admin/e_x_c_m_relations/list',
        type: 'clients',
        view: 'EXCMRelationsList'
      },
      {
        name: i18n.t('menu.relations.calendar'),
        path: '/admin/e_x_c_m_relations/calendar',
        type: 'clients',
        view: 'EXCMRelationsCalendar'
      }
    ]
  }
]

export default array
